import React from 'react';
import PropTypes from 'prop-types';

import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const AdministrationDrawerSection = ({ title, open, onToggle, expanded, allowed, children }) => {

    if (!allowed)
        return null;

    return (
        <>
            <ListItemButton onClick={onToggle} sx={{ padding: '4px 4px 0px 8px' }}>
                <Box sx={{ m: 0, p: 0, minWidth: '32px' }} />
                {expanded && <ListItemText primary={title} sx={{ m: 0, p: 0 }} />}
                {!expanded ? <></> : open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open || !expanded} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <Divider />
                    {children}
                </List>
                <Divider />
            </Collapse>
        </>
    );
};

AdministrationDrawerSection.defaultProps = {
    allowed: true
};

AdministrationDrawerSection.propTypes = {
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    expanded: PropTypes.bool.isRequired,
    allowed: PropTypes.bool,
    children: PropTypes.node.isRequired
};

export default AdministrationDrawerSection;
